module.exports = __webpack_public_path__ + "img/btn_search.48fd72ff.svg";